import usersFactory from './usersFactory';
import transactionsFactory from './transactionsFactory';
import disputesFactory from './disputesFactory';

export default {
  UsersFactory: usersFactory,
  TransactionsFactory: transactionsFactory,
  DisputesFactory: disputesFactory,
};
